const checkApiByParnerId = () => {
  return "https://api-119.medpro.com.vn";
};

// Api backend
export const RESTFULL_API_URL = checkApiByParnerId();

// Api hình ảnh và nội dung
export const STATIC_CONTENT_API_URL = `https://resource.medpro.com.vn`;

// Link login tới medproId
export const MEDPRO_LOGIN = `https://id-v121.medpro.com.vn/check-phone`;
//  trên cổi đời này không còn nhánh id-v120 , id-v110 nữa . mãi mãi !

// Thời gian sống 12*60*60; // 12 tiếng
export const COOKIE_EXPIRES = 43200;

// wechat
export const SOCKET_CHAT = "wss://alpha-api.medpro.com.vn/cable";

// link thanh toán paymenthub
export const PAYMENT_HUB_URL =
  "https://payment-gateway-qrcode-testing.medpro.com.vn";

export const LINK_API_COVID19 = "https://covid19-vaccine.medpro.com.vn";

export const BO_API = "https://bo-api-testing.medpro.com.vn";
